module.exports = __webpack_public_path__ + "static/media/kayejcatapang-2.f9bdeb7c.jpg";